// Exact title aliases supported by the existing menu translations.
// Other CRM document titles are displayed unchanged.
const DocumentConst = {
    menuLabelKeys: {
        "WEB RULES": "MENUS.Label_Terms",
        "AGB & NETIQUETTE": "MENUS.Label_Terms",
        "FAQ": "MENUS.Label_FAQ",
    },
};

export const getDocumentMenuLabelKey = title => {
    const normalized = title.trim().replace(/\s+/g, " ").toUpperCase();
    return DocumentConst.menuLabelKeys[normalized] || null;
};

export default DocumentConst;
